(ns app.front.view.inspections.summary-subsection
  (:require [app.domain.application.model :as app-model]
            [app.domain.inspection.model :as inspection-model]
            [app.domain.party.model :as party-model]
            [app.domain.util :as du]
            [app.domain.workspace.model :as workspace-model]
            [app.front.ui.section :as section]
            [app.front.ui.table :as ui-table]
            [app.front.util :as futil :refer [for-frag]]
            [app.front.view.inspections.summary-list :as inspection-summary]
            [app.front.view.workspace.util :as ws-util]
            [clojure.string :as str]
            [core.db.entity.util :as eu]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub]]
            [core.user.model :as user-model]
            [core.util.util :as util]))


(def item-href
  (comp inspection-summary/inspection-href :entity/parent))

(defn deficiency-date [locale deficiency]
  (->> deficiency :entity/created (date-util/date locale)))

(defn workspace-identifier [lang item]
  (let [workspace   (-> (if (eu/is-type? :entity.type/inspection-deficiency item) (:entity/parent item) item)
                        :entity/parent
                        :entity/parent)
        application (workspace-model/workspace-application workspace)]
    (futil/str-and-desc
      (when application
        (app-model/work-target-name application lang))
      ((some-fn :workspace/municipal-case-id
                :workspace/id)
       workspace))))

(defn inspection-name [item lang]
  (-> item :entity/parent (inspection-model/inspection-name lang)))

(defn deficiency-item [locale lang deficiency]
  (let [date (deficiency-date locale deficiency)]
    {:key                  (str (-> deficiency :entity/parent :db/id) "-" date)
     :inspection-name      (inspection-name deficiency lang)
     :issuer-name          (-> deficiency :entity/creator user-model/full-name)
     :workspace-identifier (workspace-identifier lang deficiency)
     :discovery-date       date
     :href                 (item-href deficiency)}))

(defn order-item [locale lang order]
  {:workspace-identifier (workspace-identifier lang order)
   :compliant-date       (->> order :inspection.order/compliant-by-date (date-util/date locale))
   :issuer-name          (-> order :entity/creator user-model/full-name)
   :issued-to            (->> order
                              :inspection.order/issued-to
                              (map #(party-model/corporation-or-full-name % lang))
                              (str/join ", "))
   :href                 (-> order
                             :entity/parent
                             :entity/parent
                             ws-util/workspace-href)
   :key                  (-> order :entity/parent :db/id)})

(defn group-deficiencies
  "Group deficiency-entities in a way required by the `deficiencies-and-orders` component"
  [locale lang deficiencies]
  (->> deficiencies
       (filter (du/in-state-fn :inspection.deficiency.state/active))
       (sort-by :entity/created)
       (map (partial deficiency-item locale lang))
       frequencies
       (map (fn [[item number-of-deficiencies]]
              (assoc item :number-of-deficiencies number-of-deficiencies)))))

(defn group-orders [locale lang order-entities]
  (->> order-entities
       (sort-by :inspection.order/compliant-by-date)
       (mapv (partial order-item locale lang))
       distinct))

(defn default-make-inspection-subsection-props [{workspace-id  :workspace/id
                                                 address       :workspace/address
                                                 permit-number :workspace/municipal-case-id
                                                 :as           workspace}]
  {:title    (cc/link {:href       (ws-util/workspace-href workspace)
                       :class-name "font-bold"}
                      address)
   :subtitle (or permit-number workspace-id)})

(defn inspections [{:keys [tr workspaces-sub make-subsection-props reverse? hide-empty?]
                    :or   {make-subsection-props default-make-inspection-subsection-props}}]
  [:<>
   (for-frag [{workspace-id :workspace/id
               :as          workspace} (<sub workspaces-sub)
              :when (or (not hide-empty?)
                        (seq (<sub [::inspection-summary/all-inspections workspace-id])))]
     (let [opts (util/mmap {:kind :wide} reverse? tr workspace-id)]
       [section/subsection
        (make-subsection-props workspace)
        [inspection-summary/summary-list opts]]))])

(def common-cols
  [[:inspection/inspection :inspection-name {:truncate? true}]
   [:workspace/workspace
    :workspace-identifier
    {:width     "35%"
     :truncate? true}]])

(defn deficiencies-table [{:keys [tr deficiencies-sub]}]
  [ui-table/modern-responsive-table
   {:cols    (concat common-cols
                     [[:deficiencies/discovery-date
                       :discovery-date
                       {:width "170px"
                        :flex  "0"}]
                      [:inspection/issued-by
                       :issuer-name]
                      [:project/num-deficiencies
                       :number-of-deficiencies
                       {:width "170px"
                        :flex  "0"}]])
    :id-func :key
    :link    {:make-href   :href
              :description :inspection/open}
    :tr      tr
    :items   (<sub deficiencies-sub)}])

(defn orders-table [{:keys [tr orders-sub]}]
  [ui-table/modern-responsive-table
   {:cols    [[:workspace/workspace
               :workspace-identifier
               {:width     "40%"
                :truncate? true}]
              [:inspection/issued-by
               :issuer-name]
              [:inspection/compliant-by
               :compliant-date
               {:width "170px"
                :flex  "0"}]
              [:inspection/issued-to
               :issued-to
               {:width     "170px"
                :flex      "0"
                :truncate? true}]]
    :id-func :key
    :link    {:make-href   :href
              :description :inspection/open}
    :tr      tr
    :items   (<sub orders-sub)}])

(defn deficiencies-and-orders [{:keys [tr show-orders? orders-sub deficiencies-sub]}]
  [:<>
   [section/subsection-base
    [section/subsection-content {:title (tr [:project/deficiencies])}
     [deficiencies-table (util/mmap deficiencies-sub tr)]]]
   (when (and show-orders? orders-sub)
     [section/subsection-base
      [section/subsection-content {:title (tr [:project/orders])}
       [orders-table (util/mmap orders-sub tr)]]])])
